/**
 * Onboarding layout route
 * Provides a clean layout without sidebar for onboarding flows
 */

import { Outlet, createFileRoute } from '@tanstack/react-router';

import './onboarding.scss';

function OnboardingLayout() {
  return (
    <div className="onboarding-layout">
      <Outlet />
    </div>
  );
}

export const Route = createFileRoute('/onboarding')({
  component: OnboardingLayout,
});
